/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { reserveTableSchema } from "./reserveTableSchema.ts";

export const reserveSectionSchema = z.object({
	id: z.uuid(),
	name: z.string().max(100),
	schema: z.any().nullable(),
	tables: z.array(reserveTableSchema),
});
